import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'boolToText'
})
export class BoolToTextPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) {}

  transform(value, checkFalsy: boolean = true) {
    if(value === false) {
      return this.translate.instant('generic.no');
    } else if(checkFalsy === true && !value) {
      return this.translate.instant('generic.no');
    } else {
      return this.translate.instant('generic.yes');
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/shared/bool-to-text.pipe.ts